import React from "react";
import "./bannerShine.css";

const IntervendBanner = () => {
  return (
    <a
      href="https://web.intervend.rs"
      target="_blank"
      rel="noopener noreferrer"
      className="banner-shine"
      style={{
        background: "linear-gradient(135deg, #635BFF 0%, #4338ca 100%)",
        borderRadius: "1rem",
        padding: "1.2rem 1.5rem",
        margin: "1rem 0",
        cursor: "pointer",
        transition: "all 0.3s ease",
        boxShadow: "0 4px 15px rgba(99, 91, 255, 0.25)",
        color: "white",
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        textDecoration: "none",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 6px 25px rgba(99, 91, 255, 0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(99, 91, 255, 0.25)";
      }}
    >
      <div style={{
        width: "50px",
        height: "50px",
        borderRadius: "12px",
        flexShrink: 0,
        background: "rgba(255,255,255,0.15)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <svg width="28" height="28" viewBox="0 0 100 100" fill="none">
          <path d="M49.4507 78.5652L22 26H38.1033L45.9464 42.1033C46.6695 43.4939 47.337 44.8845 47.9489 46.2752C48.5607 47.6102 49.1726 49.1398 49.7845 50.8642C50.3963 49.1398 51.0082 47.6102 51.6201 46.2752C52.232 44.8845 52.8995 43.4939 53.6226 42.1033L61.4656 26H76.9015L49.4507 78.5652Z" fill="white"/>
        </svg>
      </div>
      <div style={{ flex: 1, minWidth: 0, position: "relative", zIndex: 2 }}>
        <div style={{ fontSize: "1.5rem", fontWeight: "800", lineHeight: 1.15 }}>
          Praćenje prometa i statusa mašina
        </div>
        <div style={{ fontSize: "1rem", opacity: 0.85, marginTop: "2px" }}>
          Novi Intervend interfejs · web.intervend.rs
        </div>
      </div>
      <div style={{
        padding: "0.4rem 1rem",
        background: "rgba(255,255,255,0.2)",
        borderRadius: "0.5rem",
        fontWeight: "700",
        fontSize: "0.9rem",
        border: "1px solid rgba(255,255,255,0.3)",
        whiteSpace: "nowrap",
        flexShrink: 0,
        position: "relative",
        zIndex: 2,
      }}>
        Pogledaj →
      </div>
    </a>
  );
};

export default IntervendBanner;
